import { MONITOR_BUILD_PROGRESS, MONITOR_LOG_SUBSCRIPTION } from '../subscription-queries';
import { getServiceContainer } from '@datalabs/edl_common_ui';
export class SubscriptionService {
  /**
   * Subscribe to the log pushed on a given pipeline, could be build or data extraction, execution
   * @param pipelineRef usually the pod reference or pipeline reference
   * @returns
   */
  subscribeToLog(pipelineRef, messageHandler, closeHandler, lastId) {
    const webSocketService = getServiceContainer().resolve('WebSocketService');
    return webSocketService.createWebSocket(pipelineRef, MONITOR_LOG_SUBSCRIPTION, {
      pipelineRef, lastId
    }, messageHandler, closeHandler);
  }
  subscribeToBuildProgress(buildId, messageHandler, closeHandler) {
    const webSocketService = getServiceContainer().resolve('WebSocketService');
    return webSocketService.createWebSocket(buildId, MONITOR_BUILD_PROGRESS, {
      build: buildId,
    }, messageHandler, closeHandler);
  }
}
export const subscriptionService = new SubscriptionService();
